
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#infoShareFilled_svg__clip0_121_94)"}},[_c('path',{attrs:{"d":"M17.628.5H2.375A2.365 2.365 0 000 2.853v15.294A2.365 2.365 0 002.375 20.5h15.25A2.365 2.365 0 0020 18.147V2.853A2.36 2.36 0 0017.628.5zm-2.936 15.664l-1.703-.88a1.213 1.213 0 01-1.648-.004 1.064 1.064 0 010-1.56 1.213 1.213 0 011.648-.004l1.703-.88c-.12-.537.193-1.076.736-1.267.543-.19 1.152.025 1.43.507.277.481.14 1.083-.324 1.413a1.216 1.216 0 01-1.523-.1l-1.703.88c.034.153.034.31 0 .461l1.703.88a1.216 1.216 0 011.523-.099c.463.33.6.932.323 1.413-.277.482-.886.698-1.43.507-.542-.19-.856-.73-.735-1.267zM2.752 9.206c0-.494.34-.882.772-.882h6.174c.432 0 .772.388.772.882s-.34.882-.772.882H3.524c-.433 0-.772-.388-.772-.882zm9.373-3.235H3.47c-.403 0-.722-.389-.722-.883s.319-.882.722-.882h8.651c.404 0 .722.388.722.882s-.316.883-.72.883h.002z","fill":"currentColor"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"infoShareFilled_svg__clip0_121_94"}},[_c('rect',{attrs:{"width":"20","height":"20","fill":"currentColor","transform":"translate(0 .5)"}})])])])
          )
        }
      }
    